import React, { Component } from "react"
import { connect } from "react-redux"
import styled, { injectGlobal, css } from 'styled-components'
import Link, { navigateTo} from "gatsby-link"
import { find, filter } from 'lodash'
import { rgba } from 'polished'
import moment from 'moment'

import { MetaTags } from '../components'

import { fetchSettings, getSettings, updateSettings } from '../store/settings'

import { warmBrown, coolBrown, grey } from '../styles/themes'
import { container, bgImage, button, bgIcon, innerContainer, hoverState, headerHeight } from '../styles/global'
import { heading2, paragraph, caption, heading, projectIntro } from '../styles/type'
import { media } from '../styles/utils'

class Journal extends Component {

	state = {
        data : [],
        activeCategory: 'all'
	}
		
	componentWillMount = () => {
        const { updateSettings, fetchSettings } = this.props;
        fetchSettings()

		this.setState({
            data: this.props.data.wordpressJournal,
            activeCategory: this.props.pathContext.section || 'all'
        })
        
        updateSettings({
            theme: {
                text: '#595850',
                background: '#F0F0F0',
            }
        })
    }

    componentDidMount = () => {
        let siteWrapper = document.getElementById('site-wrapper')
        siteWrapper.style.background = '#F0F0F0';
    }
    
    renderCatNav = () => {
        const { data, activeCategory } = this.state;

        if (data.cats) {
            const cats = data.cats.map((cat, i) => {
                return (
                    <CatLink
                        key={i}
                        to={`/journal/section/${cat.slug}`}
                        selected={activeCategory == cat.slug}
                    >
                        {cat.title}
                    </CatLink>
                )
            })  

            return (
                <CatNav>
                    <Heading>Filter:&nbsp;</Heading>
                    <CatLink 
                        to={`/journal`}
                        selected={activeCategory == 'all'}
                    >
                        All
                    </CatLink>
                    {cats}
                </CatNav>
            )
        }
    }

    componentWillUnmount = () => {
        let siteWrapper = document.getElementById('site-wrapper')
        siteWrapper.style.background = null;
    }

    getArticles = () => {
		const { data, activeCategory} = this.state;

		if (!data.articles) return;

		if (activeCategory !== 'all') {
			return filter(data.articles, { catSlug: activeCategory })
		} else {
			return data.articles
		}
    }
    
    renderArticles = () => {
        const { data, activeCategory } = this.state;
        const articles = this.getArticles()

        if (articles) {
            const items = articles.map((article, i) => {
                const acf = JSON.parse(article.acf_json);

                let isLarge = acf.is_featured_format;
                if (isLarge === undefined) isLarge = false;
                // if(i % 6 == 0) isLarge = true; //every 6th is large format

                return (
                    <div
                        className={`article ${isLarge ? 'large' : 'medium'}`}
                        key={i}
                        onClick={() => navigateTo(`/journal/${article.slug}`)}
                    >

                        <ListImageLink
                            image={acf.hero_image_listing.sizes.large}
                            to={`/journal/${article.slug}`}
                        />

                        <Info>
                            <TitleLink
                                to={`/journal/${article.slug}`}
                            >
                                {article.title}
                            </TitleLink>

                            <Meta>
                                <Category>{article.catTitle}</Category>
                            </Meta>

                            {isLarge && acf.listing_description &&(
                                <Description
                                    dangerouslySetInnerHTML={{__html: acf.listing_description }}  
                                />
                            )}
                        </Info>

                    </div>
                )
            })   

            return (
                <Articles>
                    <Container>
                        {items}
                    </Container>
                </Articles>
            )
        }
    }

  	render() {
        const splashActive = this.props.settings.splashActive;
        const { data } = this.state;

        let firstPostACF;

        if (data.articles) {
            firstPostACF = JSON.parse(data.articles[0].acf_json);           
        }

		return (
			<Wrapper
                active={splashActive == false}
            >

                {data && (
                    <MetaTags 
                        title={`Paul Conrad Architects — Journal`}
                        description={firstPostACF.meta_description}
                        url={`https://www.conradarchitects.com/journal`}
                        image={firstPostACF.hero_image.sizes.medium2}
                    />
                )}

                {this.renderArticles()}
                {this.renderCatNav()}

			</Wrapper>
		)	
  	}
}

const Wrapper = styled.div`
	display: flex;
    flex-direction: row;
	width: 100%;
	z-index: 2;
    box-sizing: border-box;
    transition: all 0.75s ease;
	transition-delay: 0.4s;
	will-change: transform;
    transform: translateY(100px);
	opacity: 0;
    background: #F0F0F0;

    ${media.tablet`
        flex-direction: column;
        align-items: center;
        padding: 0;
    `}

	${props => {
		if (props.active) return css`
			transform: translateY(0);
			opacity: 1;
		`
	}}
`


// category navigation
const Heading = styled.div``
const CatLink = styled(Link)`
    ${props => {
        if (props.selected) return css`
            opacity: 1!important;
        `
    }}
`
const CatNav = styled.div`
    order: -1;
    align-self: flex-start;
    position: sticky;
    top: calc(${headerHeight.desktop}px + 10rem);
    display: flex;
    flex-direction: column;
    width: 180px;

    ${media.laptop`
        top: calc(${headerHeight.laptop}px + 10rem);
    `}

    ${media.tablet`
        order: 1;
        align-self: initial;
        top: initial;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        box-sizing: border-box;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 70px;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        background: #F0F0F0;
    `}

    ${media.phone`
        justify-content: flex-start;
        align-items: initial;
        overflow-x: auto;
        overflow-y: hidden;
        height: auto;
        padding: 20px 0;
        padding-bottom: calc(20px + env(safe-area-inset-bottom));
    `}

    ${Heading}, ${CatLink} {
        ${caption};
        text-indent: 0!important;
        margin-bottom: 1rem;
        opacity: 0.5;

        /* &:not(:nth-child(2)) {
            opacity: 0.5;
        } */

        ${media.laptop`
            font-size: 12px;
            line-height: 12px;
        `}

        ${media.tablet`
            &:not(:first-child) {
                margin-left: 5rem;
            }
        `}

        ${media.phone`
            &:first-child {
                margin-left: auto;
                padding-left: 40px;
            }
            &:last-child {
                margin-right: auto;
                padding-right: 40px;
            }
        `}
    }

    ${CatLink} {
        
    }

    /* mobile only filter heading */
    ${Heading} {
        display: none;

        ${media.tablet`
            display: flex;
        `}
    }
`


// articles listing
const Container = styled.div``
const Articles = styled.div`
    min-height: 100vh;
    ${innerContainer};
    margin-left: auto;
    margin-right: auto;

    ${media.tablet`
        transform: none;
        padding-top: 10rem;
        padding-bottom: 5rem;
        min-height: calc(100vh - 150px);
    `}

    ${media.phone`
        margin: 0;
        padding-top: 0;
        min-height: calc(100vh - 160px);
	`}

    ${Container} {
        display: flex;
        flex-flow: row wrap;
        margin-left: -2.5rem;
        margin-right: -2.5rem;

        ${media.phone`
            margin: 0;
            flex-direction: column;
        `}
    }
`

const ListImageLink = styled(Link)`
	background-image: url(${props => props.image});
	${bgImage}
`


// article type styles

const TitleLink = styled(Link)`
    display: flex;
    margin-bottom: 2rem;
    ${projectIntro};
    ${hoverState};
`
const Category = styled.div``
const Date = styled.div``
const Description = styled.div``
const Meta = styled.div`
	display: flex;

    > *:nth-child(2) {
        margin-left: 3px;
    }
`

const Info = styled.div`
    background-color: white;

    ${Category}, ${Date}, ${Description} {
        &, * {
            font-family: 'Scto';
            font-size: 14px;
            line-height: 16px;
            color: #999999;

            ${media.laptop`
                font-size: 10.5px;
                line-height: 12px;
            `}
        }
    }

    ${Description} {
        margin-top: auto;

        ${media.phone`
            display: none;
        `}
    }
`

injectGlobal`
    .article {
        display: flex;
        margin-bottom: 5rem;
        padding-left: 2.5rem;
        padding-right: 2.5rem;
        box-sizing: border-box;

        &:hover {
            cursor: pointer;
        }

        &.large {
            flex: 0 1 100%;
            flex-direction: row;

            ${ListImageLink} {
                flex: 0 1 50%;/* fallback */
                flex: 0 1 calc(50% - 2.5rem);
                height: 380px;

                ${media.laptop`
                    height: 280px;
                `}

                ${media.tablet`
                    height: 274px;
                `}
            }

            ${Info} {
                flex: 1 1 50%;
                display: flex;
                flex-direction: column;
                padding: 5rem;
                box-sizing: border-box;

                ${TitleLink} {
                    ${heading};
                    text-align: left!important;

                    ${media.phone`
                        font-size: 16.5px;
                        line-height: 18px;
                    `}
                }
            }

            ${media.tablet`
                flex: 0 1 50%;
                flex-direction: column;
                height: 280px;

                ${ListImageLink} {
                    height: auto;
                    flex: 1;    
                }

                ${Info} {
                    flex: 0 1 auto;
                    padding: 2rem 3rem 3rem;
                }
            `}
        }

        &.medium {
            flex: 0 1 50%;
            flex-direction: column;
            height: 408px;

            ${media.laptop`
                height: 310px;
            `}

            ${media.tablet`
                height: 280px;
            `}

            ${ListImageLink} {
                flex: 1 0 280px;
            }

            ${Info} {
                padding: 2rem 3rem 3rem;
            }
        }


        /* shared mobile styles */
        ${media.phone`
            flex: none;
            flex-direction: column;
            height: 280px;
            padding-left: 0;
            padding-right: 0;

            ${ListImageLink} {
                flex: 1 0 180px !important;
            }

            ${Info} {
                flex: none;
                padding: 2rem 3rem 3rem;
            }
        `}
    }
`


const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Journal);


export const pageQuery = graphql`
	query Journal {
		wordpressJournal {
            articles {
                ... on articles_4 {
                    title
                    slug
                    publishedDate
                    acf_json
                }
            }
		}
	}
`



// WEBPACK FOOTER //
// ./src/pages/Journal.js